import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { withRouter, Link } from 'react-router-dom';
import { compose } from 'recompose';
import classnames from 'classnames';

import { ClassProp, WithRouterProps } from 'helpers/types';
import { Theme } from 'config';

const styles = (theme: Theme) => {
  return {
    breadcrumb: {
      width: '1127px',
      display: 'flex',
      listStyleType: 'none',
      padding: 0,
    },
    item: {
      '&:not(:last-child):after': {
        content: `'>'`,
        fontSize: '.850rem',
        color: theme.darkGray,
        fontWeight: 500,
      },
    },
    section: {
      color: '#2185d0c9',
      fontWeight: 500,
      padding: '0 .25rem',
      fontSize: '.850rem',
      cursor: 'pointer',
    },
    disabled: {
      color: theme.darkGray,
      pointerEvents: 'none',
    },
  };
};

type Props = WithRouterProps & {
  classes: ClassProp<ReturnType<typeof styles>>;
  className?: string;
  disabledRoutes?: string[];
};

const Breadcrumb: FunctionComponent<Props> = ({
  classes,
  className,
  location,
  disabledRoutes = [],
}) => {
  const [, ...paths] = location.pathname.split('/');

  return (
    <ul className={classnames(className, classes.breadcrumb)}>
      {paths.map((path: string, index: number) => {
        const disabled =
          index === paths.length - 1 || disabledRoutes.includes(path);

        return (
          <li className={classes.item} key={path}>
            <Link
              to={`/${paths.slice(0, paths.indexOf(path) + 1).join('/')}`}
              className={classnames(classes.section, {
                [classes.disabled]: disabled,
              })}
            >
              {path}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default compose<Props, any>(withRouter, withStyles(styles))(Breadcrumb);
